import { sendAcceptanceLog } from '../api/aws';

export const RGPD_SET_SETTINGS = 'RGPD_SET_SETTINGS';
export const RGPD_SET_VISIBLE = 'RGPD_SET_VISIBLE';
export const RGPD_SET_OPENED = 'RGPD_SET_OPENED';
export const RGPD_SET_FORCEDISPLAY = 'RGPD_SET_FORCEDISPLAY';
export const RGPD_SET_EVERYTHING = 'RGPD_SET_EVERYTHING';

export const FUNCTIONALITY = 'functionality';
export const GTAG = 'google-tag-manager';

export const setSettings = (choices = {}) => ({
  type: RGPD_SET_SETTINGS,
  payload: choices,
});

export const setVisible = (payload = true) => ({
  type: RGPD_SET_VISIBLE,
  payload,
});

export const setOpened = (payload = true) => ({
  type: RGPD_SET_OPENED,
  payload,
});

export const setForceDisplay = (payload = true) => ({
  type: RGPD_SET_FORCEDISPLAY,
  payload,
});

export const setEverything = (payload) => ({
  type: RGPD_SET_EVERYTHING,
  payload,
});

export const setSettingsAndClose = (settings) => async (dispatch) => {
  dispatch(setSettings(settings));
  dispatch(setVisible(false));

  await sendAcceptanceLog(settings);
};
